export const translations = {
    estimatedValue: {
        es: "Valor estimado",
        en: "Estimated value"
    }
}